"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeWizard = exports.makeWizardContext = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var general_1 = require("utils/general");
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
var makeWizardContext = function () { return react_1.default.createContext(null); };
exports.makeWizardContext = makeWizardContext;
var makeWizard = function (WizardContext, options) { return function (_a) {
    var _b;
    var steps = _a.steps, initialStep = _a.initialStep, onNextStep = _a.onNextStep, onPrevStep = _a.onPrevStep, onEnd = _a.onEnd, children = _a.children, blockBackFromFirst = _a.blockBackFromFirst;
    var location = (0, react_router_dom_1.useLocation)();
    var wzStep = new URLSearchParams(location.search).get('wzStep');
    var getWizardStepByOffset = (0, general_1.getStepByOffset)(steps);
    var _c = __read(react_1.default.useState((_b = wzStep !== null && wzStep !== void 0 ? wzStep : initialStep) !== null && _b !== void 0 ? _b : steps[0]), 2), currentStep = _c[0], setStep = _c[1];
    var onNextClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (onNextStep === null || onNextStep === void 0 ? void 0 : onNextStep(currentStep))];
                case 1:
                    _a.sent();
                    setStep(getWizardStepByOffset(currentStep, 1));
                    return [2 /*return*/];
            }
        });
    }); };
    var goBackStep = function () {
        onPrevStep === null || onPrevStep === void 0 ? void 0 : onPrevStep(currentStep);
        setStep(getWizardStepByOffset(currentStep, -1));
    };
    var contextValues = react_1.default.useMemo(function () {
        var idx = steps.indexOf(currentStep);
        return {
            onNextClick: onNextClick,
            onPrevClick: idx !== 0 ? goBackStep : undefined,
            setStep: setStep,
            stepNumber: idx + 1,
            totalSteps: steps.length,
            currentStep: currentStep,
            steps: steps,
            onEnd: onEnd,
            blockBackFromFirst: blockBackFromFirst,
            stepTrackingEvent: options === null || options === void 0 ? void 0 : options.stepTrackingEvent,
        };
    }, [currentStep, steps, onPrevStep, onNextStep, blockBackFromFirst]);
    return ((0, jsx_runtime_1.jsx)(WizardContext.Provider, __assign({ value: contextValues }, { children: children })));
}; };
exports.makeWizard = makeWizard;
exports.default = exports.makeWizard;
